import React from "react";
import Grid from "@mui/material/Grid";

export default function FormSectionSubHeader({
  title,
  badge, 
  sx = {}
}) {
  return (
    <Grid item xs={12}>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginTop: "30px",
          marginBottom: "5px",
          paddingLeft: "4px",
          ...sx
        }}
      >
        <div
          style={{
            fontSize: "11px",
            fontWeight: 600,
            letterSpacing: "1.5px",
            color: "#667085",
            textTransform: "uppercase",
            whiteSpace: "nowrap"
          }}
        >
          {title}
        </div>

        {badge && (
          <div
            style={{
              background: "#F3F4F6",
              color: "#475467",
              fontSize: "10px",
              fontWeight: 600,
              padding: "4px 10px",
              borderRadius: "999px",
              textTransform: "uppercase",
              whiteSpace: "nowrap"
            }}
          >
            {badge}
          </div>
        )}
      </div>
    </Grid>
  );
}